import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");
if (!container) {
  // ⚠️ ممنوع الفشل الصامت: من غير الجذر مفيش واجهة أصلًا
  throw new Error("عنصر #root مش موجود في index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
